import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit'
import {
  BrandKitInput,
  PrintStoreBrandKitQuery
} from '@dtx-company/flow-codegen/src/code/generated.types'
import { PatchCollection } from '@reduxjs/toolkit/dist/query/core/buildThunks'
import { printStoreQueries } from './printStoreQueries'

export const savePrintStoreBrandKitQueryData = (
  currentState: PrintStoreBrandKitQuery,
  item: BrandKitInput
): void => {
  Object.assign(currentState, {
    printStoreBrandKit: {
      logoImage: item.logoImage,
      primaryText: item.primaryText,
      primaryColor: item.primaryColor,
      secondaryColor: item.secondaryColor
    }
  })
}

export const getPatchResultSaveBrandKit = (
  item: BrandKitInput,
  dispatch: ThunkDispatch<any, any, AnyAction>
): PatchCollection => {
  return dispatch(
    printStoreQueries.util.updateQueryData('printStoreBrandKit', {}, currentState => {
      savePrintStoreBrandKitQueryData(currentState, item)
    })
  )
}
